import { useQuery } from "@tanstack/react-query";
import { NotificationCenterKeys } from "web_myplann/Api/NotificationCenter/notificationCenterKeys";
import {
	getNotificationCenterRecentV2,
	type TimelineItemCategoryEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponseQuery } from "web_myplann/Infrastructure/Api/ApiUtils";

const STALE_TIME_MS = 60_000;

interface RecentTimelinePreviewParams {
	categories: TimelineItemCategoryEnum[];
	dateFrom: string;
	dateTo: string;
	limit: number;
}

export const useRecentTimelinePreviewQuery = (
	params: RecentTimelinePreviewParams,
) => {
	return useQuery({
		queryKey: NotificationCenterKeys.recentPreview(
			params.categories,
			params.dateFrom,
			params.dateTo,
			params.limit,
		),
		queryFn: processResponseQuery(() =>
			getNotificationCenterRecentV2(
				undefined,
				params.categories,
				params.dateFrom,
				params.dateTo,
				params.limit,
			),
		),
		staleTime: STALE_TIME_MS,
	});
};
